module.exports = __webpack_public_path__ + "media/3-42.04933977.wav";